import { createSelector } from 'reselect';
import _ from 'lodash';

import { RootState } from '..';

export const selectSettings = (state: RootState) => {
  return state.settings;
};

export const selectLang = (state: RootState) => {
  return state.settings.lang;
};

export const selectTexts = createSelector(selectSettings, selectLang, (settings, lang) => {
  return settings.texts[lang];
});

export const selectGeneralTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'general', {});
});

export const selectLoginPageTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'loginPage', {});
});

export const selectActionsPanelTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'actionsPanel', {});
});

export const selectHeaderTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'Header', {});
});

export const selectRoomContentTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'RoomContent', {});
});

export const selectPopUpsTexts = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'popUps', {});
});

export const selectHints = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'hints', {});
});

export const selectRoles = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'roles', {});
});

export const selectConnectionsControll = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'connectionsControll', {});
});

export const selectTermsFooter = createSelector(selectTexts, (texts) => {
  return _.get(texts, 'termsFooter', {});
});
